module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-09-03 at 11.31.13 AM.71f3f4a1.jpeg";